import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useActionToast } from '@/Hooks/useActionToast';
import type { TourUpdatePayload } from '../Types/Tours.types';
import { updateTour } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';

export const useUpdateTour = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: TourUpdatePayload }) =>
      updateTour(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.details() });
      toast.success('Tour salvo');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível salvar o tour', error);
    },
  });
};
